import React, { useEffect, useCallback, useState } from "react";
import { headsetLogin } from "../../services/api/userService.ts";
import { newHeadset } from "../../services/api/headsetService.ts";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  InputGroup,
  InputGroupText,
} from "reactstrap";
//import { logUser } from "../../store/auth/login/actions.js";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
//import { useNavigate } from "react-router-dom";

// import

const Login = () => {
  const dispatch = useDispatch();
  //const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    message: "",
  });
  const [pid, setPID] = useState("");
  const [isLoginPressed, setIsLoginPressed] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  document.title = "Login | iXimanager";

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get("pid");
    setPID(pid);
  }, []);

  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  const validateForm = useCallback(() => {
    let newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [email, password]);

  const onLoginPress = useCallback(async () => {
    //const userProvider = new UserProvider();
    setIsLoginPressed(true);
    if (validateForm()) {
      try {
        // const userData = { email: email, password: password };
        //dispatch(logUser(userData, navigate));
        const res = await headsetLogin(email, password);
        console.log("result headset login: ----------------");
        console.log(res.res.user);
        const headsetData = {
          headset_PID: pid,
          headset_NAME: null,
          headset_MODEL: null,
          headset_GROUP_ID: 1,
          headset_USER_ID: res.res.user.user_ID,
        };
        newHeadset(headsetData);
        console.log("Register data headset login:", email, password);
        setErrors({});
      } catch (error) {
        if (error instanceof Error) {
          console.log("Registration failed:", error.message);
          setErrors({ ...errors, message: error.message });
        }
      }
    }
  }, [validateForm, email, password, dispatch, errors]);
  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <img
                        src="/iXiVERSE-NEON.png"
                        alt="test"
                        height="25%"
                        width="25%"
                      />
                      <h3>iXiMANAGER</h3>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">
                      Welcome Back !
                    </h4>

                    <Form className="form-horizontal" action="#">
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="username">
                              Email
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="userpassword"
                            >
                              Password
                            </label>
                            <InputGroup>
                              <input
                                type={passwordVisible ? "text" : "password"}
                                value={password}
                                className="form-control"
                                id="userpassword"
                                placeholder="Enter password"
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <InputGroupText
                                onClick={togglePasswordVisibility}
                              >
                                {passwordVisible ? "Hide" : "Show"}
                              </InputGroupText>
                            </InputGroup>
                          </div>

                          <Row>
                            <Col>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customControlInline"
                                />
                                <label
                                  className="form-label form-check-label"
                                  htmlFor="customControlInline"
                                >
                                  Remember me
                                </label>
                              </div>
                            </Col>
                            <Col className="col-7">
                              <div className="text-md-end mt-3 mt-md-0">
                                <Link
                                  to="/auth-recoverpw"
                                  className="text-muted"
                                >
                                  <i className="mdi mdi-lock"></i> Forgot your
                                  password?
                                </Link>
                              </div>
                            </Col>
                          </Row>
                          <div className="d-grid mt-4">
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                              onClick={onLoginPress}
                            >
                              Log in
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              {/* { <div className="mt-5 text-center">
                    <p className="text-white-50">
                  Don't have an account ?{" "}
                  <Link
                    to={`/headset-register?pid=${pid}`}
                    className="fw-medium text-primary"
                  >
                    {" "}
                    Register{" "}
                  </Link>{" "}
                </p> 
                <p className="text-white-50">
                  © {new Date().getFullYear()} Upzet. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Themesdesign
                </p>
              </div>} */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
